import React, { useEffect, useState } from "react";
import Navbar from "../../components/shared/Navbar/Navbar";
import Footer from "../../components/shared/Footer/Footer";
import "./Careers.css";
import CareersHero from "../../components/pages/Careers/CareersHero/CareersHero";
import CareersIntro from "../../components/pages/Careers/CareersIntro/CareersIntro";
import CareersOpenPositions from "../../components/pages/Careers/CareersOpenPositions/CareersOpenPositions";
import { getPageContent } from "../../api/content";
import { useTranslation } from "react-i18next";

const unwrapSectionData = (section) => {
  if (section == null) return section;
  if (typeof section === "string") {
    const t = section.trim();
    if (t.startsWith("{")) {
      try {
        const parsed = JSON.parse(t);
        if (parsed && typeof parsed === "object") return unwrapSectionData(parsed);
      } catch {
        return section;
      }
    }
    return section;
  }
  if (typeof section !== "object") return section;
  if (section.data && typeof section.data === "object") return section.data;
  return section;
};

const normalizeSectionSlug = (key) =>
  String(key || "")
    .toLowerCase()
    .replace(/[_\s-]+/g, "");

const findPageSection = (root, slug) => {
  if (!root || typeof root !== "object") return undefined;
  const target = normalizeSectionSlug(slug);
  const hit = Object.keys(root).find((k) => normalizeSectionSlug(k) === target);
  return hit != null ? root[hit] : undefined;
};

const Careers = () => {
  const { i18n } = useTranslation();
  const [careersContent, setCareersContent] = useState({});

  useEffect(() => {
    let isMounted = true;
    const load = async () => {
      try {
        const data = await getPageContent({
          page: "careers",
          language: (i18n.language || "en").toLowerCase(),
        });
        if (isMounted) setCareersContent(data || {});
      } catch {
        if (isMounted) setCareersContent({});
      }
    };
    load();
    return () => {
      isMounted = false;
    };
  }, [i18n.language]);

  return (
    <div className="careers-page">
      <Navbar theme="dark" />
      <div className="careers-page-content-guide">
        <CareersHero content={unwrapSectionData(findPageSection(careersContent, "hero"))} />
        <CareersIntro content={unwrapSectionData(findPageSection(careersContent, "intro"))} />
        <div id="careers-open-positions">
          <CareersOpenPositions />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Careers;
